
// progresReducer.ts
import { CHANGE_PROGRES, ChangeProgresAction } from '../actions/progresAction';

interface ProgresState {
  currentProgres: number;
}

const initialState: ProgresState = {
  currentProgres: 0,
};

const progresReducer = (state = initialState, action: ChangeProgresAction): ProgresState => {
  switch (action.type) {
    case CHANGE_PROGRES:
      return {
        ...state,
        currentProgres: action.payload,
      };
    default:
      return state;
  }
};

export default progresReducer;

// progresReducer.ts
// import { CHANGE_PROGRES, ChangeProgresAction } from '../actions/progresAction';

// interface ProgresState {
//   progressByJourney: Record<string, number>; // Use a record to store progress by Learning Journey
// }

// const initialState: ProgresState = {
//   progressByJourney: {},
// };

// const progresReducer = (state = initialState, action: ChangeProgresAction): ProgresState => {
//   switch (action.type) {
//     case CHANGE_PROGRES:
//       return {
//         ...state,
//         progressByJourney: {
//           ...state.progressByJourney,
//           [action.payload.journeyId]: action.payload.progress,
//         },
//       };
//     default:
//       return state;
//   }
// };

// export default progresReducer;
